import React, { useRef, useEffect } from "react";
import { TextFieldProps } from "@mui/material";
import { StyledTextField } from "./styles";

interface AutoResizeTextareaProps
  extends Omit<TextFieldProps, "value" | "onChange"> {
  value: string;
  onChange: (value: string) => void;
}

const AutoResizeTextarea = ({
  value,
  onChange,
  ...props
}: AutoResizeTextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <StyledTextField
      inputRef={textareaRef}
      value={value}
      onChange={handleInput}
      multiline
      minRows={1}
      placeholder="Type something..."
      variant="outlined"
      fullWidth
      sx={{
        "& textarea": {
          overflow: "hidden",
          resize: "none",
        },
      }}
      {...props}
    />
  );
};

export default AutoResizeTextarea;
